var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfrOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0069 4.88235C11.0661 4.38115 11.4914 4 12 4H15C15.2931 4 15.5715 4.12862 15.7615 4.35186C15.8906 4.50355 15.9701 4.68856 15.9931 4.88235H18C18.2957 4.88235 18.5761 5.01317 18.7661 5.23968C18.9561 5.46618 19.0362 5.76515 18.9848 6.05628L17.3027 15.5796L18.1245 19.8093C18.1815 20.1024 18.1044 20.4057 17.9145 20.6361C17.7245 20.8665 17.4415 21 17.1429 21H6.85715C6.55852 21 6.27552 20.8665 6.08556 20.6361C5.89559 20.4057 5.81855 20.1024 5.87551 19.8093L6.69728 15.5796L5.01525 6.05628C4.96383 5.76515 5.04387 5.46618 5.23387 5.23968C5.42387 5.01317 5.70436 4.88235 6.00001 4.88235H11.0069ZM10.8444 6.88235H7.19211L8.55315 14.5882H10.2205L10.8444 6.88235ZM14.4606 14.5882H15.4469L16.8079 6.88235H15.7083L14.4606 14.5882ZM13.8251 6H12.9223L12.5842 10.1765H13.1489L13.8251 6ZM15.4613 16.5882H8.53871L8.07014 19H15.9299L15.4613 16.5882Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfrOpen);
export default __webpack_public_path__ + "static/media/mfr-open.ac6bebb00e8d1951de3b0b8c8d1bbe82.svg";
export { ForwardRef as ReactComponent };